import React, { useEffect, useState } from "react";
import api from "@/lib/axios";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

const CommentThread = ({ taskId, staffId }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchComments = async () => {
    try {
      const res = await api.get(`/solo-mdsh-api/maintenance/tasks/${taskId}/comments`);
      setComments(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("❌ Failed to load comments:", err);
      setComments([]);
    }
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) return;
    setLoading(true);
    try {
      await api.post(`/solo-mdsh-api/maintenance/tasks/${taskId}/comments`, {
        comment_text: newComment.trim(),
        staff_id: staffId || null,
      });
      setNewComment("");
      fetchComments();
    } catch (err) {
      console.error("❌ Failed to add comment:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (taskId) fetchComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  return (
    <div className="mt-6">
      <h4 className="text-white text-md font-semibold mb-2">💬 Comments</h4>

      <div className="space-y-3 max-h-64 overflow-y-auto mb-3">
        {comments.map((c) => (
          <div key={c.comment_id} className="bg-neutral-800 p-3 rounded-xl text-sm">
            <div className="text-slate-300">
              <strong>{c.full_name || "Anonymous"}</strong> ·{" "}
              <span className="text-xs opacity-60">
                {c.created_at ? new Date(c.created_at).toLocaleString() : "—"}
              </span>
            </div>
            <p className="text-slate-200 mt-1 whitespace-pre-line">{c.comment_text}</p>
          </div>
        ))}
        {comments.length === 0 && <p className="text-slate-400">No comments yet.</p>}
      </div>

      <div className="flex flex-col gap-3">
        <Textarea
          rows={3}
          placeholder="Write a comment..."
          className="bg-neutral-900 text-white"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        />
        <Button
          onClick={handleAddComment}
          className="bg-green-700 hover:bg-green-600 w-full"
          disabled={loading || !newComment.trim()}
        >
          {loading ? "Submitting..." : "Add Comment"}
        </Button>
      </div>
    </div>
  );
};

export default CommentThread;